export const SET_DATA = 'SET_DATA';
export const SET_HEADER_TYPE = 'SET_HEADER_TYPE';
